
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.752 9.687L5.117 8.052l-.546.545 2.181 2.18 4.673-4.672-.545-.546-4.128 4.128z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 .653a7.347 7.347 0 100 14.694A7.347 7.347 0 008 .653zM0 8a8 8 0 1116 0A8 8 0 010 8z"}})])
          )
        }
      }
    